module.exports = __webpack_public_path__ + "static/img/f.7d48f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f.png
// module id = 2YIi
// module chunks = 0